<template>
  <div class="message sms-wrapper">
    <div class="data-description" v-if="!classicCampaignsEnabled" style="margin-bottom:10px">
      <b>stashboard creator</b>

      <div>
        use the creator below to craft whatever message you want! add text, creative images, and extensions to your campaign and we will generate a stashboard for your members
        (<a href="https://springbig.zendesk.com/hc/en-us/articles/1500010744021-Webinar-The-Next-Level-of-Texting-with-stashboards" target="_blank">see tutorial</a>)
      </div>
    </div>

    <campaign-creator style="margin-bottom:10px;" v-if="useCampaignEditor2"/>

    <div class="sms-and-extentions" v-if="!useCampaignEditor2">
      <sms
          :activeMessage="activeMessage"
          :messageModuleName="messageModuleName"
          :isRounded="referredMessaged"
          :smsSend="smsSend"
          :smsContent="smsContent"
          @updateCampaign="updateCampaign"
          @updateInvalidCharacters="updateInvalidCharacters">
      </sms>
      <extensions
          v-if="!isBackup && !classicCampaignsEnabled"
          :campaignSendTime="campaignSendTime"
          :isBudzAutoCampaign="isBudzAutoCampaign"
          :messageModuleName="messageModuleName"
          :messageType="messageType"
          :messageTypeId="messageId"
          :referredMessaged="referredMessaged"
          @updateCampaign="updateCampaign">
      </extensions>
    </div>
  </div>
</template>

<script>
  import DeliverabilityScore from './DeliverabilityScore'
  import Extensions from '../Extensions/Extensions'
  import { mapState, mapGetters } from 'vuex'
  import Preview from './Preview'
  import Sms from '../Sms/Sms'
  import DeliverabilityScoreFixMixin from "../../mixins/DeliverabilityScoreFixMixin";
  import TextNotificationPicker from "../TextNotificationPicker";
  import CampaignCreator from "../Campaigns2/campaign-creator";

  export default {
    mixins: [DeliverabilityScoreFixMixin],
    props: {
      campaign: Object,
      activeMessage: Boolean,
      campaignSendTime: String,
      isBudzAutoCampaign: Boolean,
      messageModuleName: {
        default: 'message',
        type: String
      },
      messagePriority: Number,
      smsSend: Boolean
    },

    name: 'Message',

    components: {
      DeliverabilityScore,
      Extensions,
      Preview,
      Sms,
      TextNotificationPicker,
      CampaignCreator
    },

    data() {
      return {
        invalidCharacters: null,
        referredMessaged: false,
        showBackup: false,
        smsContent: ''
      }
    },

    methods: {
      updateCampaign(data) {
        this.$emit('update', data)
      },

      updateInvalidCharacters(invalids) {
        this.invalidCharacters = invalids
      }
    },

    created() {
      this.referredMessaged = this.messagePriority === -1
    },

    computed: {
      ...mapState({
        isBackup (state) { return state[this.messageModuleName]?.isBackup },
        messageId (state) { return state[this.messageModuleName]?.messageId },
        messageType (state) { return state[this.messageModuleName]?.messageType }
      }),

      ...mapGetters(['classicCampaignsEnabled', 'useCampaignEditor2']),

      moduleName: function() { return this.messageModuleName }
    },
  }
</script>

<style lang="css">
  .data-description b {
    font-size: 1.25rem
  }

  .notification-label, .notification-item {
    font-size: 1rem;
    text-align: left;
  }

  .notification-label-description, .notification-item-description {
    font-size: 1rem;
    font-family: AileronThin;
    text-align: left;
  }

  .notification-item-description {
    color: #128ff9;
    font-weight: bold;
  }
</style>
